import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { IconButton, Typography } from "@totalsoft/rocket-ui";
import CancelIcon from "@mui/icons-material/Cancel";
import { DropdownItemContainer } from "./NotificationStyles";

class NotificationItemComponent extends PureComponent {
  render() {
    const { notification, onMarkAsRead, onDismiss, text } = this.props;
    return (
      <DropdownItemContainer>
        <Typography onClick={onMarkAsRead(notification)}>{notification.isRead ? text : <b>{text}</b>}</Typography>
        <IconButton onClick={onDismiss(notification)} color="primary" variant="text" size="tiny">
          <CancelIcon sx={{ width: "20px", height: "20px" }} />
        </IconButton>
      </DropdownItemContainer>
    );
  }
}

NotificationItemComponent.propTypes = {
  notification: PropTypes.object.isRequired,
  onMarkAsRead: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  text: PropTypes.string
};

export default NotificationItemComponent;
